import React, { useState, useEffect, useCallback } from 'react';

// context
import { PartnershipContext } from './types';

// utils
import { IUserApiResponse } from '@widgets/header/types';
import {
    SegmentEventNameTypes,
    INTERNET_PRODUCT,
    SUB_PRODUCT_NAME,
} from 'utils/segment/constants';
import { useViewport } from '@utils/responsive';

// events
import {
    pageEvent,
    trackEvent,
    waitForAnalyticsLoad,
} from '@acko-tech/building-blocks.ui.acko-analytics';

// helpers
import { fetchUserDetails } from './helpers';

export const PartnershipProvider: React.FC<{ children: React.ReactNode }> = ({
    children,
}) => {
    const [userDetails, setUserDetails] = useState<
        IUserApiResponse | undefined
    >({
        addresses: [],
        amazon_prime: false,
        date_of_birth: null,
        email: '',
        name: '',
        phone: '',
        gender: '',
        whatsapp_optin: false,
        is_amazon: false,
    });
    const { isMobile } = useViewport();

    useEffect(() => {
        fetchUserDetails(setUserDetails);
    }, [setUserDetails]);
    // Your contex
    const sendSegmentEventForInternet = useCallback(
        (eventNameType = SegmentEventNameTypes.ACTION, eventData) => {
            const props = {
                product: INTERNET_PRODUCT,
                sub_product_name: SUB_PRODUCT_NAME,
                email: !!userDetails?.email ? userDetails?.email : undefined,
                phone: !!userDetails?.phone ? userDetails?.phone : undefined,
                name: !!userDetails?.name ? userDetails?.name : undefined,
                page_url: window?.location?.href,
                referrer: document?.referrer,
                platform: isMobile ? 'mweb' : 'web',
                device: navigator?.userAgent,
                ...eventData,
            };

            if (eventNameType === SegmentEventNameTypes.VIEW)
                waitForAnalyticsLoad().then(() =>
                    pageEvent(eventNameType, props)
                );
            if (
                eventNameType === SegmentEventNameTypes.ACTION ||
                eventNameType === SegmentEventNameTypes.EXCEPTION
            )
                trackEvent(eventNameType, props);
        },
        [userDetails, isMobile]
    );
    //
    // t logic here
    return (
        <PartnershipContext.Provider value={{ sendSegmentEventForInternet }}>
            {children}
        </PartnershipContext.Provider>
    );
};
